module.exports = __webpack_public_path__ + "static/media/4_bill_smile.c8327ddf.svg";